import { ChangeEvent } from 'react';
import styled from 'styled-components';

interface SurveyTextInputProps {
  inputValue: string | undefined;
  placeholder: string;
  onChange: (newValue: string | undefined) => void;
  button?: JSX.Element;
}

export const SurveyTextInput = ({ placeholder, inputValue, onChange, button }: SurveyTextInputProps) => {
  return (
    <InputBackground>
      <InputWrapper>
        <Input
          type={'text'}
          placeholder={placeholder}
          value={inputValue}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            if (event.target.value) {
              const newValue = event.target.value;
              onChange(newValue);
            } else {
              onChange(undefined);
            }
          }}
        />
      </InputWrapper>

      {button}
    </InputBackground>
  );
};

const InputBackground = styled.div`
  display: flex;
  padding: var(--radius-large, 16px);
  align-items: flex-start;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  gap: 8px;
`;

const InputWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  gap: var(--radius-medium, 8px);
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  min-height: 40px;

  gap: 8px;

  padding: 10px 16px;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);

  text-align: left;

  &::placeholder {
    color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);

    /* Body/Medium/m-regular */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */

    text-align: left;
  }
`;
